export const SidebarIdBoardSettings = 'BOARD_SETTINGS' as const;
